import TagGroupsMixin from "../../../mixins/tag-groups-mixin";

Vue.component("system-saved-replies", {

  mixins: [TagGroupsMixin],

  props: ["savedRepliesList"],

  computed: {

    tagGroups() {

      if (this.form.category === "Maintenance") {
        return this.tagGroupAlways.concat(this.tagGroupProperty).concat(this.tagGroupMaintenance);
      }

      return this.form.category === "Inspections" ?
        this.tagGroupAlways.concat(this.tagGroupProperty).concat(this.tagGroupInspections) :
        this.tagGroupAlways;
    }
  },


  methods: {
    openSavedReply(id) {
      $(id).prop("aria-expanded", "true");
      $(id).addClass("show");
    }
  }

});
